class DrawerMenu extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      close: '[data-drawer-close]',
      overlay: '[data-overlay]',
      trigger: '[data-drawer-trigger]'
    };

    this.els = {
      body: document.body,
      drawers: this,
      overlay: this.querySelector(this.selectors.overlay)
    };

    this.initialise();
  }

  initialise() {
    document.querySelector(`[data-module-drawers-trigger="menu"]`).addEventListener('click', this.handleClick.bind(this));
  }

  /**
   * Click handler to close the popup
   *
   * @param {Event} e
   */
  handleClick(e) {
    this.querySelector('.drw-Drawer-fromLeft').classList.toggle('active')
    e.target.classList.toggle('hd-Mobile_Trigger-active')
    e.target.parentElement.classList.toggle('hd-Mobile_Trigger-active')
    document.querySelector('main').classList.toggle('lyt-Site_Main-moveRight')
    this.classList.toggle('drw-Drawers-active')
    
    // Toggle overflow-hidden class on HTML element
    document.documentElement.classList.toggle('overflow-hidden')
  }
}

customElements.define('drawer-menu', DrawerMenu);
